import React from 'react';

import Table from 'components/common/Table';

import { picklistApi } from 'api';

import { PICKLIST_DETAIL_ITEMS_COLUMNS } from 'constants/picklist';

const PicklistProducts = ({ picklistId }) => {
  return (
    <Table
      title={`Picklists #${picklistId} Items`}
      apiService={picklistApi}
      columns={PICKLIST_DETAIL_ITEMS_COLUMNS}
      fetchConfig={{
        method: 'getProductsOfPicklist',
        enablePagination: true,
      }}
      resourceId={picklistId}
      initialPageSize={25}
      initialFilter={{ tab: 'items' }}
    />
  );
};

export default PicklistProducts;
